import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { includedInEveryVolume } from '../data/content';
export function IncludedSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="incluye-titulo" data-id="element-107" data-mp="3lct2vv2xgdxy">
      <div className="mx-auto max-w-3xl" data-id="element-108" data-mp="37h7iy2bjwkce">
        <h2 id="incluye-titulo" className="text-center font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl" data-id="element-109" data-mp="3cdpk6s7oa0jz">
          Todos Los Volúmenes Incluyen
        </h2>

        <ul className="mt-7 grid gap-2.5" data-id="element-110" data-mp="7yy42xizv76h">
          {includedInEveryVolume.map(({
          title,
          description
        }) => <li key={title} className="flex items-start gap-3 rounded-xl border border-cream-300/70 bg-cream-50 px-5 py-3.5" data-id="element-111" data-mp="3qd7eto7ng819">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-[#DCE5DE]" data-id="element-112" data-mp="mwqj7okmptk5">
                <CheckCircleIcon className="h-3 w-3 text-[#3D5B4A]" aria-hidden="true" data-id="element-113" data-mp="ro8mwke1e88t" />
              </span>
              <p className="text-[0.85rem] leading-relaxed text-forest-700/90" data-id="element-114" data-mp="3qi5lz4u74irw">
                <span className="font-semibold text-forest-800" data-id="element-115" data-mp="3mgbqrc2rs6z4">{title}</span> — {description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}